module.exports = __webpack_public_path__ + "r-v3/img/check_white.8519ebba.svg";